import React from 'react';
import _ from 'lodash';

import { useSelector, shallowEqual } from 'react-redux';
import { SeekChatContainer } from '../chat';

import styles from './session.module.scss';
import { Dataset } from '../../../../types/dataseek';
import { SeekChat } from '../../../../types/seek';

const EMPTY_CHATS: any[] = [];

interface SeekSessionContainerProps {
  id: string | null;
  dataset: Dataset;
  answerQuestion: (question: any) => void;
}

export const SeekSessionContainer: React.FC<SeekSessionContainerProps> = ({ id, dataset, answerQuestion }) => {
  const chats = useSelector(
    (state: any) => state.seek.chats || EMPTY_CHATS,
    shallowEqual
  );

  return (
    <div className={styles.session}>
      {chats.map((record: any, index: number) => {
        const uuid = record.uuid;

        return (
          <SeekChatContainer key={uuid}
            dataset={dataset}
            chat={record}
            answerQuestion={answerQuestion}
          />
        )
      })}
    </div>
  );
}